<script lang="ts">
  import Center from './center.svelte';

  export let gap = 10;
  export let padding = 10;
  export let cols: number;

  let gridTemplate = new Array(cols).fill('1fr').join(' ');
</script>

<Center>
  <div
    style="padding: {padding}px 15px {padding +
      2}px 15px; grid-template-columns: {gridTemplate}; gap: {gap}px"
  >
    <slot />
  </div>
</Center>

<style>
  div {
    display: grid;
  }
</style>
